<script>
import ChargeResource from '@/resources/charge'

export default {
    name: 'AccountTransactions',
    data() {
        return {
            loading: true,
            chargeResources: []
        }
    },
    async mounted() {
        this.chargeResources = await ChargeResource.all({ query: { amount_cents__gt: 0 } })
        this.loading = false
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Transactions</h4>
            <p class="text-muted mb-0">Your recent billing history.</p>
        </div>

        <div v-if="loading" class="text-center py-5">
            <b-spinner />
        </div>

        <b-table-simple v-else-if="chargeResources.length > 0" responsive class="account-transactions-table">
            <b-thead>
                <b-tr>
                    <b-th>Amount</b-th>
                    <b-th>Description</b-th>
                    <b-th>Receipt</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(charge, i) in chargeResources" :key="i">
                    <b-td class="text-nowrap font-weight-bold">{{ charge.get('currency_symbol') || '$' }}{{ charge.amount() }}</b-td>
                    <b-td>
                        {{ charge.get('notes') || 'No Description' }}
                        <br />
                        <small class="text-muted">{{ charge.createdTimePretty() }}</small>
                        <small class="text-danger d-block" v-if="charge.get('errors')">{{ charge.get('errors') }}</small>
                    </b-td>
                    <b-td>
                        <a :href="charge.get('receipt_url')" target="_blank" v-if="charge.attributes.receipt_url">
                            <b-icon icon="box-arrow-up-right" /> View
                        </a>
                        <span v-else class="text-muted">&mdash;</span>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <div v-else class="text-center py-5">
            <b-icon icon="receipt" scale="2" class="text-muted d-block mx-auto mb-3" />
            <p class="text-muted">No transactions on record.</p>
        </div>
    </div>
</template>

<style scoped>
.account-transactions-table td,
.account-transactions-table th {
    white-space: nowrap;
}
.account-transactions-table td:nth-child(2) {
    white-space: normal;
    min-width: 180px;
}
</style>
